// extracted by mini-css-extract-plugin
module.exports = {"top__nav":"style-module__top__nav___sLlgV","backIcon":"style-module__backIcon___eg9hf","web__logo":"style-module__web__logo___NlpuD"};